import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '@/src/app/uygulamalar/hmi-pano/pano/pages/personel/services/hmi-lookup.service';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'gorev-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gv-edit">
      <div class="gv-baslik">
        <div class="gv-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
        </div>
        <span>Görev Bilgileri</span>
      </div>

      <div class="gv-form">
        <div class="form-grup">
          <label>Görev Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('gorevAdi')" (ngModelChange)="guncelle('gorevAdi', $event)" placeholder="Görev adı..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Atanan Kişi</label>
          <div class="input-wrap">
            <nz-select [ngModel]="deger('atanan')" (ngModelChange)="guncelle('atanan', $event)" nzPlaceHolder="Kişi seçin..." nzAllowClear nzShowSearch style="width:100%">
              @for (per of lookup.personeller(); track per._id) {
                <nz-option [nzValue]="per.ad + ' ' + per.soyad" [nzLabel]="per.ad + ' ' + per.soyad"/>
              }
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Öncelik</label>
            <div class="input-wrap">
              <nz-select [ngModel]="deger('oncelik') || 'Normal'" (ngModelChange)="guncelle('oncelik', $event)" style="width:100%">
                <nz-option nzValue="Düşük" nzLabel="Düşük" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#94a3b8"></span>Düşük</span></nz-option>
                <nz-option nzValue="Normal" nzLabel="Normal" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#3b82f6"></span>Normal</span></nz-option>
                <nz-option nzValue="Yüksek" nzLabel="Yüksek" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#f59e0b"></span>Yüksek</span></nz-option>
                <nz-option nzValue="Acil" nzLabel="Acil" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#ef4444"></span>Acil</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Tahmini Süre</label>
            <div class="input-wrap">
              <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('tahminiSure')" (ngModelChange)="guncelle('tahminiSure', $event)" placeholder="ör: 2 saat"/>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }
    .gv-edit { display: flex; flex-direction: column; padding: 0; }
    .gv-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .gv-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #10b981, #34d399); color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(16,185,129,0.35); }
    .gv-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .gv-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #10b981, #34d399, #10b981); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap input[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(16,185,129,0.1); outline: none; }
    .input-wrap ::ng-deep .ant-select-selector { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
    .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; box-shadow: 0 0 0 2px rgba(16,185,129,0.1) !important; }
    .ac-opt { display: flex; align-items: center; gap: 8px; }
    .ac-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  `],
})
export class GorevEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);
  constructor() { super(); this.lookup.personelleriYukle(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
